module.exports = __webpack_public_path__ + "static/media/protected_shield.f012929b.svg";